import React, { Component } from 'react';
import styles from './Slider.module.css';
import { restructureResponse } from '../../helpers/sparql';
import throttle from 'lodash/throttle';
// import isEqual from 'lodash/isEqual';

class Slider extends Component {
  state = {};

  // componentDidMount() {
  //   if (this.props.data) {
  //     let item = restructureResponse(this.props.data)[0];
  //     let keyURI = this.props.data.head.vars[0];
  //     let value = item[keyURI];
  //     this.props.publish(this.props.publishVariable, value);
  //   }
  // }

  defineMaxMinValue() {
    let headVars = this.props.data.head.vars;
    let key = headVars[0]; // eg. oprichtingsDatum
    let items = restructureResponse(this.props.data);
    let minValue = 1000000;
    let maxValue = -1000000;

    items.forEach(item => {
      let value = item[key];
      try {
        if (typeof value === 'string') value = Number(value);
      } catch (error) {
        console.log(error);
      }
      if (value < minValue) minValue = value;
      if (value > maxValue) maxValue = value;
    });
    return { minValue, maxValue };
  }

  onChange = event => {
    this.setState({
      value: event.target.value
    });
    this.onChangeThrottle();
  };

  onChangeThrottle = throttle(() => {
    let value = this.state.value;
    if (value) this.props.publish(this.props.publishVariable, value);
  }, 200);

  render() {
    if (!this.props.data) return null;

    let { minValue, maxValue } = this.defineMaxMinValue();

    // let value = this.props.pubsub[this.props.publishVariable] || maxValue;
    let value = this.state.value || maxValue;

    return (
      <div className={styles.main}>
        <div className={styles.label}>{this.props.label}</div>
        <div className={styles.container}>
          <div className={styles.rangeValue}>{minValue}</div>
          <input
            className={styles.slider}
            type="range"
            min={minValue}
            max={maxValue}
            value={value}
            step="1"
            onChange={this.onChange}
          />
          <div className={styles.rangeValue}>{maxValue}</div>
        </div>
      </div>
    );
  }
}

export default Slider;
